"use client";

import { InfoResponse } from "@/types/info";
import {
  createContext,
  PropsWithChildren,
  useContext,
  useDeferredValue,
} from "react";

const InfoContext = createContext<{
  data?: InfoResponse;
} | null>(null);

export const useInfo = () => {
  const context = useContext(InfoContext);
  if (!context) {
    throw new Error("useInfo must be used within a InfoProvider");
  }
  return context;
};

export default function InfoProvider({
  children,
  data,
}: PropsWithChildren<{
  data?: InfoResponse;
}>) {
  const dataValue = useDeferredValue(data);

  return (
    <InfoContext.Provider value={{ data: dataValue }}>
      {children}
    </InfoContext.Provider>
  );
}
